export default __webpack_public_path__ + "static/media/whiteLogo.2b9b2de4.png";